import { Site } from '@envato/foundation-types'
import { connect } from 'react-redux'

import { IRootState } from '../../../common/reducers'
import SiteMeta from './siteMeta'

interface IOwnProps {
  seoMeta: any
  location: any
  currentSite: Site
  noIndex: boolean
  baseUrl: string
  canonicalPath: string
}

interface IStateProps {
  menuConfig: any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { common: { menuConfig } } = state

  return { menuConfig }
}

const SiteMetaContainer = connect<IStateProps, {}, IOwnProps, IRootState>(
  mapStateToProps
)(SiteMeta)

export default SiteMetaContainer
